import { render, staticRenderFns } from "./HistoryCards.vue?vue&type=template&id=23199d17&scoped=true"
import script from "./HistoryCards.vue?vue&type=script&lang=js"
export * from "./HistoryCards.vue?vue&type=script&lang=js"
import style0 from "./HistoryCards.vue?vue&type=style&index=0&id=23199d17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23199d17",
  null
  
)

export default component.exports